module.exports = __webpack_public_path__ + "img/removedynamicCard.ca7c87fc.svg";